
export default {
    name: 'TimeDuration',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: true,
        },
        separator: {
            type: String,
            default: ',',
        },
        settings: {
            type: Object,
            default: () => ({ hours: true, minutes: true }),
        },
        text: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            weeks: 0,
            days: 0,
            hours: 0,
            minutes: 0,
        }
    },
    computed: {
        weekItems() {
            return Array.from({ length: 53 }, (_, w) => w)
        },
        dayItems() {
            return Array.from({ length: 31 }, (_, d) => d)
        },
        hourItems() {
            return Array.from({ length: 24 }, (_, h) => h)
        },
        minuteItems() {
            return Array.from({ length: 60 }, (_, m) => m)
        },
        totalSeconds() {
            return this.weeks * 604800 + this.days * 86400 + this.hours * 3600 + this.minutes * 60
        },
        rules() {
            return {
                number: this.isValidNumber,
                required: () => this.totalSeconds > 0,
            }
        },
    },
    methods: {
        isValidNumber(value: string | number) {
            if (typeof value === 'number') return value >= 0
            return /^\d+$/g.test(value)
        },
        update(value: number | string) {
            if (!this.isValidNumber(value)) return
            this.$emit('input', this.totalSeconds)
        },
        calculateTimes() {
            let value = this.value
            if (this.settings.weeks) {
                this.weeks = Math.floor(value / 604800)
                value = value % 604800
            }
            if (this.settings.days) {
                this.days = Math.floor(value / 86400)
                value = value % 86400
            }
            if (this.settings.hours) {
                this.hours = Math.floor(value / 3600)
                value = value % 3600
            }
            if (this.settings.minutes) {
                this.minutes = Math.floor(value / 60)
            }
        },
    },
    created() {
        this.calculateTimes()
        this.$watch('value', this.calculateTimes)
    },
}
